import { getElementDeserializer, setDefaults } from '@udecode/slate-plugins';
import brElement from './element';

const deserializeBr = options => {
  const { br } = setDefaults(options, brElement);

  return {
    element: getElementDeserializer({
      type: br.type,
      rules: [{ nodeNames: 'BR' }],
    }),
  };
};

export default deserializeBr;
